import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { useTranslation } from "react-i18next";
import { RefObject } from "react";

type SendButtonProps = {
    onClick: () => void;
    disabled?: boolean;
    ref?: RefObject<HTMLButtonElement>;
    style?: { cursor: string }

}
const SendButtonStyle = styled.button`
    border-radius: 20px;
    cursor: pointer;
    border: none;
    display: block;
    padding: 20px;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 20px;
    width: 100%;
    border-radius: 9999px;
    background: #F0F1F5;
    color: #0A0F15;

    &:disabled {
        background-color: #919599;;
        cursor: default;
    }
`;


export default (props: SendButtonProps) => {
    const { t } = useTranslation();
    return (
        <SendButtonStyle onClick={props.onClick} disabled={props.disabled} ref={props.ref} style={props.style}> 
            <div>
                <FontAwesomeIcon style={{ marginRight: 8 }} icon={faArrowRight} />
                {t('button_confirm')}
            </div>
        </SendButtonStyle>
    )
}

//button_continue